/* RESPONSIBLE TEAM: team-frontend-tech */
import Predicate from 'predicates/models/predicate';
import { ternary } from '@intercom/pulse/lib/computed-properties';
export default Predicate.extend({
  isEditable: true,
  isNumericType: true,
  genericType: 'numeric',
  goalComparison: ternary('isUserEventPredicate', 'triggered', 'increase'),
  initializeDefaultValue() {
    this.set('predicate.value', this.getDefaultValue());
  },
  getDefaultValue() {
    if (this.hasNoValue && this.isValueBasedComparison) {
      return '';
    } else {
      return null;
    }
  }
});